/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setCampaignSupporterData} from '../api'

export const useMutationSetCampaignSupporterData = createReactQueryMutationHook('setCampaignSupporterData', setCampaignSupporterData)
